import React from 'react'
import PropTypes from 'prop-types'
import IconButton from './icon-button'

const ZoomInIconButton = ({ onClick }) => (
  <IconButton iconName='zoom-in' onClick={onClick} />
)

ZoomInIconButton.defaultProps = {
  onClick: () => {}
}

ZoomInIconButton.PropTypes = {
  onClick: PropTypes.func
}

export default ZoomInIconButton



// WEBPACK FOOTER //
// ./src/ui/buttons/ZoomInIconButton.js